export default {
  "nav.home": "Startseite",
  "nav.products": "Produkte",
  "nav.guide": "Spreadsheet Guide",
  "nav.categories": "Kategorien",
  "nav.visitSite": "Hauptwebsite besuchen",

  "hero.badge": "Aktualisierte Ressourcen · Nach Kategorie sortiert",
  "hero.title": "AllChinaBuy-Tabelle",
  "hero.subtitle": "Finden Sie Produkte, Verkäufer und Einkaufsressourcen in der neuesten AllChinaBuy-Tabelle — alles an einem Ort organisiert.",
  "hero.ctaPrimary": "allchinabuy-tabelle",
  "hero.ctaSecondary": "jetzt kaufen",

  "dropdown.label": "Kategorie wählen",
  "dropdown.placeholder": "Kategorie auswählen…",

  "categories.title": "Produktkategorien entdecken",
  "categories.subtitle": "Springen Sie direkt zu der Kategorie, die Sie suchen, auf der Hauptwebsite.",

  "text.title": "Was ist die AllChinaBuy-Tabelle?",
  "text.paragraph1": "Die AllChinaBuy-Tabelle ist eine geteilte Ressource, die Produktlinks, Verkäuferinformationen und Kategorielisten in einer übersichtlichen Ansicht bündelt. Statt unzählige Seiten zu durchsuchen, können Sie sie als Ausgangspunkt nutzen, um Artikel aus Mode, Sneakers, Streetwear, Taschen und mehr zu entdecken.",
  "text.paragraph2": "Diese Website ist ein unabhängiges Informationsportal. Wir ordnen die Kategorien, damit Sie schnell von einem Thema zur Hauptwebsite gelangen, wo sich die vollständigen Produktlisten befinden.",

  "articleLink.title": "Die vollständige Anleitung lesen",
  "articleLink.subtitle": "Erfahren Sie, wie Sie die AllChinaBuy-Tabelle nutzen, was jede Kategorie enthält und wie Sie sicher einkaufen.",
  "articleLink.cta": "Anleitung lesen",

  "footer.disclaimer": "Dies ist eine unabhängige Informationsquelle. Produktlinks öffnen sich auf der Hauptwebsite kaspreadsheet.com.",
  "footer.rights": "AllChinaBuy-Tabellen-Hub.",

  "categories.shoes": "Schuhe",
  "categories.hoodies": "Hoodies/Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen/Shorts",
  "categories.headwear": "Kopfbedeckungen",
  "categories.sets": "Sets",
  "categories.underwear": "Unterwäsche",
  "categories.jersey": "Trikots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Taschen",
  "categories.belts": "Gürtel",
  "categories.perfumes": "Parfums",
  "categories.other": "Sonstiges",

  "products.featuredTitle": "Empfohlene Produkte",
  "products.featuredSubtitle": "Entdecken Sie beliebte Produkte aus dem AllChinaBuy spreadsheet. Klicken Sie, um auf der Hauptwebsite zu sehen und zu kaufen.",
  "products.viewAll": "Alle Produkte ansehen",

  "article.title": "AllChinaBuy-Tabellen-Anleitung: Produkte, Kategorien & Nutzung",
  "article.back": "Zurück zur Startseite",
  "article.published": "Aktualisiert",
  "article.intro": "Die AllChinaBuy-Tabelle ist eine der schnellsten Möglichkeiten, eine große Produktpalette aus einer einzigen organisierten Ressource zu durchsuchen. In dieser Anleitung erklären wir, was die Tabelle ist, wie die Kategorien aufgebaut sind und wie Sie von einer Kategorie zu den eigentlichen Produktlisten gelangen.",
  "article.h2.what": "Was ist die AllChinaBuy-Tabelle?",
  "article.p.what": "Die AllChinaBuy-Tabelle dient als zentrale Referenz für Produkte und Verkäufer. Sie gruppiert Artikel in klare Kategorien — Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und mehr — damit Sie schnell den gewünschten Bereich finden.",
  "article.h2.categories": "Wie die Kategorien organisiert sind",
  "article.p.categories": "Jede Kategorie auf dieser Website verlinkt direkt auf den passenden Bereich der Hauptwebsite. Wenn Sie eine Kategorie wählen, gelangen Sie direkt zu den Listen dieser Gruppe. So bleibt die Erfahrung einfach: Kategorie wählen, Link öffnen und Produkte durchsehen.",
  "article.h2.howto": "So nutzen Sie die Tabelle",
  "article.p.howto": "Beginnen Sie auf der Startseite, wählen Sie eine Kategorie aus dem Dropdown-Menü oder über die Kategorie-Schaltflächen, und Sie werden zur Hauptwebsite weitergeleitet. Dort können Sie die Produktliste durchsehen, Verkäufer vergleichen und Details prüfen.",
  "article.h2.safety": "Sicher einkaufen",
  "article.p.safety": "Überprüfen Sie vor der Bestellung stets Produktbeschreibungen, Verkäuferbewertungen und Versanddetails auf der Hauptwebsite. Schützen Sie Ihre Zahlungs- und Kontodaten und prüfen Sie Links, bevor Sie klicken.",
  "article.conclusion": "Bereit zum Entdecken? Kehren Sie zur Startseite zurück, um die Kategorien zu durchsuchen und die vollständigen AllChinaBuy-Tabellenlisten zu öffnen.",
  "article.cta": "Zurück zur AllChinaBuy-Tabelle",
};